import React from 'react'

const AdLoader = () => {
    return (
        <section class="dotscontainerLoad">
            <div class="dotLoad"></div>
            <div class="dotLoad"></div>
            <div class="dotLoad"></div>
            <div class="dotLoad"></div>
            <div class="dotLoad"></div>
        </section>
    )
}

export default AdLoader